import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "../../lib/cn.js";

interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  bodyClassName?: string;
}

export function Card({
  title,
  description,
  actions,
  className,
  bodyClassName,
  children,
  ...rest
}: CardProps) {
  return (
    <section
      className={cn(
        "rounded border border-surface-border bg-surface-panel",
        className
      )}
      {...rest}
    >
      {(title || actions) && (
        <header className="flex items-start justify-between gap-3 border-b border-surface-border px-4 py-3">
          <div>
            {title && (
              <h2 className="text-sm font-semibold text-text-primary">{title}</h2>
            )}
            {description && (
              <p className="mt-0.5 text-xs text-text-secondary">{description}</p>
            )}
          </div>
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </header>
      )}
      <div className={cn("px-4 py-3.5", bodyClassName)}>{children}</div>
    </section>
  );
}
